import axios from 'axios';
import { constants } from '../../constants';

export const postFeedback = (
  chatroomId: string,
  memberId: string,
  id: string,
  feedback: string
) => {
  const token = localStorage.getItem('token');
  return axios.post<void>(
    `${constants.endpoint}/users/${memberId}/feedback`,
    {
      chatroomId,
      answerId: id,
      feedback,
    },
    {
      headers: {
        Authorization: `bearer ${token}`,
      },
    }
  );
};
